import { observer } from 'mobx-react';
import { FC } from 'react';
import Button from '~/components/Button/Button';
import { getStore } from '~/mobx/AppStore';

interface Props {
    candidateId: string;
    isDisabledVote: boolean;
    onVotesChange: (candidateId: string, number: number | undefined) => void;
    extraVoteLabel: string;
    electionCandidateElimination: string;
    voteType: string;
}

const ActionButtons: FC<Props> = (props: Props) => {
    const btnBaseClassname = 'hover:text-[#303030] grow shrink basis-[calc(50%-0.5rem)] px-0';
    const btnExtraVoteClassName = `btn-stem ${btnBaseClassname}`;
    const btnStrikeClassName = `btn-stryk ${btnBaseClassname}`;
    const shouldShowDownVoteButton = props.electionCandidateElimination === 'true';

    return (
        <div className="vote-container flex flex-wrap gap-[10px] gap-x-[6px]">
            {props.voteType === 'extra' && (
                <Button
                    btnText={'Angre ekstrastemme'}
                    testId="extra-vote-button"
                    extendedClassName={btnExtraVoteClassName}
                    disabled={props.isDisabledVote}
                    variant="success_soft"
                    onClick={() => props.onVotesChange(props.candidateId, -1)}
                />
            )}

            {props.voteType === 'down' && (
                <Button
                    btnText={'Angre stryk'}
                    testId="extra-vote-button"
                    extendedClassName={btnStrikeClassName}
                    disabled={props.isDisabledVote}
                    variant="danger_soft"
                    onClick={() => props.onVotesChange(props.candidateId, 1)}
                />
            )}

            {props.voteType === 'normal' && (
                <Button
                    btnText={props.extraVoteLabel}
                    testId="extra-vote-button"
                    extendedClassName={`${btnExtraVoteClassName}  ${shouldShowDownVoteButton ? 'md:max-w-[250px]' : ''}`}
                    disabled={props.isDisabledVote}
                    variant="success"
                    onClick={() => props.onVotesChange(props.candidateId, 1)}
                />
            )}

            {props.voteType === 'normal' && shouldShowDownVoteButton && (
                <Button
                    btnText={'Stryk kandidat'}
                    testId="strike-button"
                    extendedClassName={`${btnStrikeClassName} md:max-w-[250px]`}
                    disabled={props.isDisabledVote}
                    variant="danger"
                    onClick={() => props.onVotesChange(props.candidateId, -1)}
                />
            )}
        </div>
    );
};

interface ActionButtonsWithStoreProps {
    candidateId: string;
}

const ActionButtonsWithStore = (props: ActionButtonsWithStoreProps) => {
    const { voteStore, candidateStore, ballotStore, previewStore } = getStore();
    const isPreview = previewStore.isInitialized;
    const isDisabledVote = candidateStore.isDisabledVote || isPreview;
    const extraVoteLabel = ballotStore.region?.regionExtraVoteLabel;
    const electionCandidateElimination = ballotStore.election?.electionCandidateElimination;
    const voteType = voteStore.getVoteType(props.candidateId);

    return (
        <ActionButtons
            candidateId={props.candidateId}
            isDisabledVote={isDisabledVote}
            onVotesChange={(candidateId, number) => voteStore.onVotesChange(candidateId, number || 0)}
            extraVoteLabel={extraVoteLabel || ''}
            electionCandidateElimination={electionCandidateElimination || ''}
            voteType={voteType}
        />
    );
};

export default observer(ActionButtonsWithStore);
